import React from "react";
import '../App.css';

const LoadingSpinner = () => {
  return <div className='spinner'></div>;
};

export default LoadingSpinner;
